import { useEffect } from 'react';
import type { Dispatch } from 'react';
import type { IMasterDocumentAdapter, DocumentState } from '../adapter/MasterDocumentAdapter.types';
import type { FactBoxSectionTemplate } from '../template/MasterDocumentTemplate.types';

export function useFactBoxData(
  sections: FactBoxSectionTemplate[],
  adapter: IMasterDocumentAdapter,
  state: DocumentState,
  dispatch: Dispatch<{ type: 'SET_FACTBOX_DATA'; sectionKey: string; data: Record<string, unknown> }>,
) {
  useEffect(() => {
    if (!state.documentId) return;

    const adapterSections = sections.filter((s) => s.dataSource === 'adapter');
    if (adapterSections.length === 0) return;

    let cancelled = false;

    for (const section of adapterSections) {
      // Skip if not visible in current state
      if (section.visibleOn && !section.visibleOn.includes(state.docState) && !section.visibleOn.includes('*')) {
        continue;
      }

      if (section.widget.type === 'statusHistory') {
        // Historial de transiciones (OP1) — usa getStatusHistory en vez de getFactBoxData
        if (!adapter.getStatusHistory) continue;
        adapter.getStatusHistory(state.documentId!).then(
          (entries) => {
            if (!cancelled) {
              dispatch({ type: 'SET_FACTBOX_DATA', sectionKey: section.key, data: { entries } });
            }
          },
          () => { /* silently ignore errors */ },
        );
      } else {
        // Resto de widgets — usa getFactBoxData genérico
        if (!adapter.getFactBoxData) continue;
        adapter.getFactBoxData(state.documentId!, section.key).then(
          (data) => {
            if (!cancelled) {
              dispatch({ type: 'SET_FACTBOX_DATA', sectionKey: section.key, data });
            }
          },
          () => { /* silently ignore factbox loading errors */ },
        );
      }
    }

    return () => { cancelled = true; };
  }, [state.documentId, state.docState, sections, adapter, dispatch]);
}
